import { render } from "./Fascias.vue?vue&type=template&id=7346a567"
import script from "./Fascias.vue?vue&type=script&lang=js"
export * from "./Fascias.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__